import {
	Component,
	EventEmitter,
	OnInit,
	TemplateRef,
	ViewChild
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT,
	PARAM_LABEL_INTERVENTION
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { ErrorResponse } from '../../models/api-response/error-response';
import { OverlappingResponse } from '../../models/api-response/overlapping-response';
import { Employee } from '../../models/employee/employee';
import { Mission } from '../../models/mission/mission';
import { DateUtils } from '../../utils/date-utils';

@Component({
	selector: 'app-resolve-conflict-modal',
	templateUrl: './resolve-conflict-modal.component.html',
	styleUrls: ['./resolve-conflict-modal.component.scss']
})
export class ResolveConflictModalComponent implements OnInit {
	mission: Mission;
	employee: Employee;
	isAssignationInProgress = false;
	overlappingResponse: OverlappingResponse;
	initialEmployee: Employee;
	selectedCalendarDate?: Date;

	getData?: EventEmitter<any>;

	labelInterventionCapitalized: string;
	labelBeneficiaireCapitalized: string;
	labelIntervenantCapitalized: string;
	labelInterventionPluralized: string;

	isMobile: boolean;

	// Swap modal
	@ViewChild('resolveConflictModal', { static: true })
	public resolveConflictModal: TemplateRef<any>;

	constructor(
		private facade: FacadeService,
		private toastService: ToastService,
		public dateUtils: DateUtils,
		public bsModalResolveConflict: BsModalRef
	) {}

	ngOnInit(): void {
		this.isMobile = this.facade.mobileService.isMobile();
		this.labelIntervenantCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_INTERVENANT
			);
		this.labelInterventionCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_INTERVENTION
			);
		this.labelInterventionPluralized =
			this.facade.dataStorageService.getLabelPluralized(
				PARAM_LABEL_INTERVENTION
			);
		this.labelBeneficiaireCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_BENEFICIAIRE
			);

		if (!this.employee) {
			this.employee = this.initialEmployee;
		}
	}

	confirmSwap() {
		this.isAssignationInProgress = !this.isAssignationInProgress;
		this.facade.missionService
			.swapMissions(
				this.mission.id,
				this.overlappingResponse.missionInConflict.id
			)
			.subscribe({
				next: () => {
					this.getData?.emit({
						dateToLoad: this.selectedCalendarDate,
						reloadEmployeesAndVacation: false,
						reloadSolution: true,
						reloadOptimInProgress: false
					});
					this.bsModalResolveConflict.hide();
					this.isAssignationInProgress = !this.isAssignationInProgress;
				},
				error: (err: ErrorResponse) => {
					this.toastService.createHttpErrorToast(
						err.error.response,
						err.status
					);
					this.isAssignationInProgress = !this.isAssignationInProgress;
				}
			});
	}

	forceAssignation(intervenantId: number) {
		this.isAssignationInProgress = !this.isAssignationInProgress;
		let missionId: number;
		let idFromMissionToGetRouteFrom: number;

		missionId = this.mission.id;
		idFromMissionToGetRouteFrom = this.overlappingResponse.missionInConflict.id;

		this.facade.missionService
			.forceAssignation(missionId, idFromMissionToGetRouteFrom)
			.subscribe({
				next: () => {
					this.getData?.emit({
						dateToLoad: this.selectedCalendarDate,
						reloadEmployeesAndVacation: false,
						reloadSolution: true,
						reloadOptimInProgress: false
					});
					this.bsModalResolveConflict.hide();
					this.isAssignationInProgress = !this.isAssignationInProgress;
				},
				error: (err: ErrorResponse) => {
					this.toastService.createHttpErrorToast(
						err.error.response,
						err.status
					);
					this.isAssignationInProgress = !this.isAssignationInProgress;
				}
			});
	}

	reassignation() {
		this.isAssignationInProgress = !this.isAssignationInProgress;
		// on désaffecte la mission qui overlaps (car c'est elle qui est affectée)
		let idOfMissionToUnassigned = this.overlappingResponse.missionInConflict.id;
		// la mission a affecté est celle en cours d'édition
		let missionToAssign = this.mission;
		// on lui assigne l'employee sélectionnée par l'user (qui est celle de l'overlapping mission)
		let idOfEmployeeToAssign: number = this.employee.id;
		const plannerId = this.facade.dataStorageService.getUser().employee.id;

		this.facade.missionService.desaffecter(idOfMissionToUnassigned).subscribe({
			next: () => {
				this.facade.missionService
					.changeMission(missionToAssign.id, idOfEmployeeToAssign, plannerId)
					.subscribe({
						next: () => {
							this.getData?.emit({
								dateToLoad: this.selectedCalendarDate,
								reloadEmployeesAndVacation: false,
								reloadSolution: true,
								reloadOptimInProgress: false
							});
							this.bsModalResolveConflict.hide();
							this.isAssignationInProgress = !this.isAssignationInProgress;
						},
						error: (err: ErrorResponse) => {
							this.toastService.createHttpErrorToast(
								err.error.response,
								err.status
							);
							this.isAssignationInProgress = !this.isAssignationInProgress;
						}
					});
			},
			error: (err: ErrorResponse) => {
				this.toastService.createHttpErrorToast(err.error.response, err.status);
			}
		});
	}
}
